export enum TOAST_MESSAGES {
  success = 'Success',
  pending = 'Promise is pending',
}

export enum TOAST_ERRORS {
  unknown = 'Unknown system error',
}
